"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffsetWithoutSeparator = exports.getOffset = void 0;
var date_fns_1 = require("date-fns");
var pad_number_to_length_1 = require("../utils/pad-number-to-length");
var getFormattedOffset = function (params, delimiter) {
    if (delimiter === void 0) { delimiter = ''; }
    var offset = date_fns_1.differenceInMinutes(params.date, params.offsetUtcDate);
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    return sign + pad_number_to_length_1.padNumberToLength(hours, 2) + delimiter + pad_number_to_length_1.padNumberToLength(minutes, 2);
};
/**
 * Returns a string representation of the time zone offset: -01:00, +00:00, ... +12:00
 * @hidden
 */
var getOffset = function (params) {
    return getFormattedOffset(params, ':');
};
exports.getOffset = getOffset;
/**
 * Returns a string representation of the time zone offset, without the separator: -0100, +0000, ... +1200
 * @hidden
 */
var getOffsetWithoutSeparator = function (params) {
    return getFormattedOffset(params);
};
exports.getOffsetWithoutSeparator = getOffsetWithoutSeparator;
//# sourceMappingURL=offset.js.map